import axios from "axios";

const { REACT_APP_API_URL } = process.env;

export const LOGIN_URL = `${REACT_APP_API_URL}agent/login`;


export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = `${REACT_APP_API_URL}agent/profile`;

export function login(number, password) {
  return axios.post(LOGIN_URL, { number, password });
}

export function getUser() {
  const timestamp = new Date().getTime();
  return axios.get(`${ME_URL}?timestamp=${timestamp}`, {
    headers: {
      'Cache-Control': 'no-cache'
    }
  })
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}
